import { render } from "./AdminActiveParkingPassChangeHistory.vue?vue&type=template&id=707181b4&scoped=true"
import script from "./AdminActiveParkingPassChangeHistory.vue?vue&type=script&lang=js"
export * from "./AdminActiveParkingPassChangeHistory.vue?vue&type=script&lang=js"

import "./AdminActiveParkingPassChangeHistory.vue?vue&type=style&index=0&id=707181b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707181b4"]])

export default __exports__